import UpcomingInterviewsCard from "./upcomingInterviewsCard";
export default UpcomingInterviewsCard;